import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "va-card" }
const _hoisted_2 = { class: "va-card-body" }
const _hoisted_3 = { class: "va-card-icon" }
const _hoisted_4 = ["onClick", "title"]

import VAIcon from '../VAIcon/VAIcon.vue'
import {PropType} from "vue";
import {VACardOptions} from "./typings";
import {useRouter} from "vue-router";
import {useRequestPagination} from "./hooks";


export default /*@__PURE__*/_defineComponent({
  __name: 'VACard',
  props: {
  uri: {
    type: String,
    required: true
  },
  options: {
    type: Object as PropType<VACardOptions>,
    required: true,
    default: () => {
      return {}
    }
  },    // 是否启用分页，默认启用
  pagination: {
    type: Boolean,
    default: true
  },
  // 调用uri时传入的默认参数，{name: 'test'}
  defaultParams: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  setup(__props, { expose: __expose }) {

const router = useRouter()

const props = __props

const {
  loading, data: source, run: reload,
  pagination: page, handleTableChange
} = useRequestPagination(props.uri, props.defaultParams)


const to = (item: any) => {
  const options = props.options?.router
  if (options?.name) {
    const query = options.defaultParams || {}
    if (options.field && options.valueField) {
      query[options.field] = item[options.valueField]
    }
    router.push({name: options.name, query: {...query}})
    return
  }
}

const formatLabel = (item: any) => {
  if (props.options?.labelFormat)
    return props.options.labelFormat(item)
  return item[props.options.label]
}

__expose({reload})


return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      tip: "Loading...",
      spinning: _unref(loading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(source), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              style: {"padding":"0 10px 10px 10px","min-width":"200px"},
              key: item.id
            }, [
              _createVNode(_component_a_card, { size: "small" }, {
                title: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "va-card-head", {}, () => [
                    _createElementVNode("span", _hoisted_3, [
                      _renderSlot(_ctx.$slots, "va-card-icon", {}, () => [
                        (__props.options.icon)
                          ? (_openBlock(), _createBlock(VAIcon, {
                              key: 0,
                              type: __props.options.icon
                            }, null, 8, ["type"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (to(item)),
                      title: __props.options.title
                    }, _toDisplayString(formatLabel(item)), 9, _hoisted_4)
                  ])
                ]),
                extra: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "va-card-action", { data: item })
                ]),
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "va-card-content", { data: item }, () => [
                    _createTextVNode(_toDisplayString(item[__props.options.content]), 1)
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ]),
      _: 3
    }, 8, ["spinning"]),
    (__props.pagination)
      ? (_openBlock(), _createBlock(_component_a_pagination, {
          key: 0,
          style: {"margin":"10px 0"},
          current: _unref(page).current,
          "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_unref(page).current) = $event)),
          pageSize: _unref(page).pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageSize) = $event)),
          "show-size-changer": "",
          total: _unref(page).total,
          onChange: _unref(handleTableChange),
          onShowSizeChange: _unref(handleTableChange)
        }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"]))
      : _createCommentVNode("", true)
  ]))
}
}

})